export default __webpack_public_path__ + "static/media/cube.1b3f71eb.png";